import PageModule from "@eisinc/Overrides/Pages/ProductDetailsPage";

export * from "@eisinc/Overrides/Pages/ProductDetailsPage";

export default PageModule;
